import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-objectif-status',
  templateUrl: './objectif-status.component.html',
  styleUrls: ['./objectif-status.component.scss'],
  standalone: false,
})
export class ObjectifStatusComponent {
  @Input() public status: string | undefined;

  @Input() public isLoading: boolean | undefined;

  @Input() public filled: boolean = false;

  @Input() public errorNew: boolean = false;

  @Input() public difference: number = 0;

  @Input() public ignoreDiffNb: boolean = true;

  constructor() {}
}
